import { Alert } from '@mui/material';
import { Button } from '@qwickapps/react-framework';
import { useMiddlewareClient } from '@qwickforge/react-client';
import { useEffect, useState } from 'react';

interface UpgradeNoticeProps {
  message: string;
}

export default function UpgradeNotice({ message }: UpgradeNoticeProps) {
  const client = useMiddlewareClient();
  const [upgradeUrl, setUpgradeUrl] = useState<string>('');

  useEffect(() => {
    const loadSettings = async () => {
      if (!client) return;
      try {
        const settings = await client.systemSettings.getAll();
        setUpgradeUrl(settings.upgrade_url || '');
      } catch (err) {
        console.error('Failed to load system settings:', err);
      }
    };
    loadSettings();
  }, [client]);

  return (
    <Alert
      severity="info"
      sx={{ mb: 3, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
      action={
        upgradeUrl && (
          <Button
            size="small"
            variant="contained"
            onClick={() => window.open(upgradeUrl, '_blank')}
          >
            Upgrade
          </Button>
        )
      }
    >
      {message}
    </Alert>
  );
}
